import React from 'react'
import { useParams } from 'react-router-dom'
import { useGetBooking } from '../../api/bookings/useGetBooking'
import { LoadingView } from '../LoadingView/LoadingView'
import { RestaurantInfo } from '../../api/restaurant/getRestaurant'
import { CreditCardFormProvider } from '../CreditCardForm/CreditCardFormProvider'
import { ReservationPaymentView } from './ReservationPaymentView'
import { Frame } from '../Frame/Frame'
import { Helmet } from 'react-helmet-async'

type ReservationDepositContainerProps = {
  restaurant: RestaurantInfo
}

export const ReservationDepositContainer = ({
  restaurant
}: ReservationDepositContainerProps) => {
  const { bookingGuid } = useParams()
  const { data: booking } = useGetBooking(
    // We're certain there's a booking guid corresponding to the route this component is used in
    bookingGuid!,
    restaurant.guid
  )

  if (!booking || !restaurant) {
    return <LoadingView />
  }

  return (
    <Frame restaurant={restaurant}>
      <Helmet>
        <title>
          {restaurant.name} - Deposit Payment - {restaurant.city},{' '}
          {restaurant.state} | Toast Tables
        </title>
      </Helmet>
      <CreditCardFormProvider>
        <ReservationPaymentView restaurant={restaurant} booking={booking} />
      </CreditCardFormProvider>
    </Frame>
  )
}
